import { render, staticRenderFns } from "./MarketTrends.vue?vue&type=template&id=531826d8&scoped=true&"
import script from "./MarketTrends.vue?vue&type=script&lang=js&"
export * from "./MarketTrends.vue?vue&type=script&lang=js&"
import style0 from "./MarketTrends.vue?vue&type=style&index=0&id=531826d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531826d8",
  null
  
)

export default component.exports